import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ProcessingStatItem } from '../ProcessingStatsItem';

export const FCHTransCount = ({ onChildValueChange }) => {
  const handleFCSReport = (e) => {
    e.preventDefault();
    onChildValueChange('FCH');
  };

  return (
    <ProcessingStatItem title="Field Change Transaction Count">
      <Table.Container title="">
        <Table.TableBody>
          <Table.Row>
            <Table.Cell>
              <Link onClick={handleFCSReport} href="#">
                View Field Change Summary
              </Link>
            </Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
    </ProcessingStatItem>
  );
};
